import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2023大渡口十大江湖菜评选活动-分享';
const baseUrl = 'SDJHC0921';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/activity`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'activity',
      name: `${baseUrl}-activity`,
      component: () => import('./pages/Activity.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'activityDetail',
      name: `${baseUrl}-activityDetail`,
      component: () => import('./pages/ActivityDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;

